import { fintracStrAddressFields } from 'app/modules/fintracStr/formConfig/definitions/common/address';
import { fintracStrPersonDetailsFields } from 'app/modules/fintracStr/formConfig/definitions/common/personDetails';
import { fintracStrTelephoneNumberFields } from 'app/modules/fintracStr/formConfig/definitions/common/telephoneNumber';
import {
  FintracFormFieldConditional,
  FintracFormSingleField,
} from 'app/modules/fintracStr/models';

export const fintracStrPersonContactFields = (
  basePath: (sectionIndex: number, fieldSectionIndex?: number[]) => string,
  hideIfTrue?: FintracFormFieldConditional,
): FintracFormSingleField[] => [
  ...fintracStrPersonDetailsFields(hideIfTrue),
  ...fintracStrAddressFields(basePath, hideIfTrue),
  ...fintracStrTelephoneNumberFields(basePath, hideIfTrue),
];
